/*============================================================================
  Ajax the add to cart experience by revealing it in a side drawer
  Plugin Documentation - http://shopify.github.io/Timber/#ajax-cart
  (c) Copyright 2015 Shopify Inc. Author: Carson Shold (@cshold). All Rights Reserved.

  This file includes:
    - Basic Shopify Ajax API calls
    - Ajax cart plugin

  This requires:
    - jQuery 1.8+
    - handlebars.min.js (for cart template)
    - modernizr.min.js
    - snippet/ajax-cart-template.liquid

  Customized version of Shopify's jQuery API
  (c) Copyright 2009-2015 Shopify Inc. Author: Caroline Schnapp. All Rights Reserved.
  
  Modified by yang@onerockwell
  
==============================================================================*/
if ((typeof ShopifyAPI) === 'undefined') {
    ShopifyAPI = {};
}

/*============================================================================
  API Helper Functions
==============================================================================*/
function attributeToString(attribute) {
    if ((typeof attribute) !== 'string') {
        attribute += '';
        if (attribute === 'undefined') {
            attribute = '';
        }
    }
    return jQuery.trim(attribute);
};

/*============================================================================
  API Functions
==============================================================================*/
ShopifyAPI.onCartUpdate = function(cart) {
    // alert('There are now ' + cart.item_count + ' items in the cart.');
};

ShopifyAPI.updateCartNote = function(note, callback) {
    var $body = $(document.body),
        params = {
            type: 'POST',
            url: '/cart/update.js',
            data: 'note=' + attributeToString(note),
            dataType: 'json',
            beforeSend: function() {
                $body.trigger('beforeUpdateCartNote.ajaxCart', note);
            },
            success: function(cart) {
                if ((typeof callback) === 'function') {
                    callback(cart);
                } else {
                    ShopifyAPI.onCartUpdate(cart);
                }
                $body.trigger('afterUpdateCartNote.ajaxCart', [note, cart]);
            },
            error: function(XMLHttpRequest, textStatus) {
                $body.trigger('errorUpdateCartNote.ajaxCart', [XMLHttpRequest, textStatus]);
                ShopifyAPI.onError(XMLHttpRequest, textStatus);
            },
            complete: function(jqxhr, text) {
                $body.trigger('completeUpdateCartNote.ajaxCart', [this, jqxhr, text]);
            }
        };
    jQuery.ajax(params);
};

ShopifyAPI.onError = function(XMLHttpRequest, textStatus) {
    var data = eval('(' + XMLHttpRequest.responseText + ')');
    if (!!data.message) {
        alert(data.message + '(' + data.status + '): ' + data.description);
    }
};

/*============================================================================
  POST to cart/add.js returns the JSON of the cart
    - Allow use of form element instead of just id
    - Allow custom error callback
  Yang@onerockwell Added ShopifyAPI.addMultipleItems
==============================================================================*/
ShopifyAPI.addMultipleItems = function(data, callback, errorCallback) {
    var $body = $(document.body),
        params = {
            type: 'POST',
            url: '/cart/add.js',
            data: data,
            dataType: 'json',
            beforeSend: function(jqxhr, settings) {
                $body.trigger('beforeAddItem.ajaxCart');
            },
            success: function(line_item) {
                if ((typeof callback) === 'function') {
                    callback(line_item);
                } else {
                    ShopifyAPI.onItemAdded(line_item);
                }
                $body.trigger('afterAddItem.ajaxCart', [line_item]);
            },
            error: function(XMLHttpRequest, textStatus) {
                if ((typeof errorCallback) === 'function') {
                    errorCallback(XMLHttpRequest, textStatus);
                } else {
                    ShopifyAPI.onError(XMLHttpRequest, textStatus);
                }
                $body.trigger('errorAddItem.ajaxCart', [XMLHttpRequest, textStatus]);
            },
            complete: function(jqxhr, text) {
                $body.trigger('completeAddItem.ajaxCart', [this, jqxhr, text]);
            }
        };
    jQuery.ajax(params);
};

ShopifyAPI.addItemFromForm = function(form, callback, errorCallback) {
    var $form = jQuery(form);
    console.log($form);

    var addItemOriginal = function() {
        var $body = $(document.body),
        params = {
            type: 'POST',
            url: '/cart/add.js',
            data: $form.serialize(),
            dataType: 'json',
            beforeSend: function(jqxhr, settings) {
                $body.trigger('beforeAddItem.ajaxCart', form);
            },
            success: function(line_item) {
                if ((typeof callback) === 'function') {
                    callback(line_item, form);
                } else {
                    ShopifyAPI.onItemAdded(line_item, form);
                }
                $body.trigger('afterAddItem.ajaxCart', [line_item, form]);
            },
            error: function(XMLHttpRequest, textStatus) {
                if ((typeof errorCallback) === 'function') {
                    errorCallback(XMLHttpRequest, textStatus, $form);
                } else {
                    ShopifyAPI.onError(XMLHttpRequest, textStatus);
                }
                $body.trigger('errorAddItem.ajaxCart', [XMLHttpRequest, textStatus]);
            },
            complete: function(jqxhr, text) {
                $body.trigger('completeAddItem.ajaxCart', [this, jqxhr, text]);
            }
        };
        jQuery.ajax(params);
    }

    // Check if item sku is quantity restricted
    var stopAddItem = false;
    var limitQty = false;
    var itemHTML = form.querySelector('[data-product-json]').textContent;
    var addingQty = parseInt(form.querySelector('#Quantity').value);
    var itemData;
    var itemSKU;

    if (itemHTML) {
        itemData = JSON.parse(itemHTML);
        itemSKU = itemData.variants[0].sku;
    }

    var qtyMax = null;
    if (itemData) {
        var i, count = ORW.sku_list.length;
        for (i = 0; i < count; i++) {
            var skus_restricted_array = ORW.sku_list[i].split(',');

            var j, count2 = skus_restricted_array.length;
            for (j = 0; j < count2; j++) {
                var skuLimit = skus_restricted_array[j];
                if (skuLimit === itemSKU) {
                    limitQty = true;
                    qtyMax = parseInt(ORW.qty_limit[i]);
                    break;
                }
            }

            if (limitQty) {
                break;
            }
        }
    }

    // If item is limited, check cart state for item and if item is at max or if qty being added would go above the max
    if (limitQty && qtyMax) {
        if (addingQty > qtyMax) {
            console.log(`Quantity of ${itemSKU} is restricted to ${qtyMax}`)
            // Show error message if on PDP
            var productErrorMsg = document.querySelector('.product-quantity-max-error');
            if (productErrorMsg) {
                productErrorMsg.classList.remove('hide');
            }
            return;
        }

        $.ajax({
            type: 'GET',
            url: '/cart',
            dataType: 'json',
            success: function(cartData){
                var i, count = cartData.items.length;
                for (i = 0; i < count; i++) {
                    var item = cartData.items[i]
                    if (item.sku === itemSKU && ((item.quantity + addingQty) > qtyMax) ) {
                        console.log(`Quantity of ${itemSKU} is restricted to ${qtyMax}`)
                        // Show error message if on PDP
                        var productErrorMsg = document.querySelector('.product-quantity-max-error');
                        if (productErrorMsg) {
                            productErrorMsg.classList.remove('hide');
                        }
                        stopAddItem = true;
                    }
                }
                if (!stopAddItem) {
                    // Hide error message if on PDP and showing
                    var productErrorMsg = document.querySelector('.product-quantity-max-error');
                    if (productErrorMsg) {
                        productErrorMsg.classList.add('hide');
                    }
                    addItemOriginal(); 
                }
            },
            error: function(err){
                console.log(err)
            }
        });
    } else {
        addItemOriginal();
    }
    
};

// Get from cart.js returns the cart in JSON
ShopifyAPI.getCart = function(callback) {
    $(document.body).trigger('beforeGetCart.ajaxCart');
    jQuery.getJSON('/cart.js', function(cart, textStatus) {
        if ((typeof callback) === 'function') {
            callback(cart);
        } else {
            ShopifyAPI.onCartUpdate(cart);
        }
        $(document.body).trigger('afterGetCart.ajaxCart', cart);
    });
};

// POST to cart/change.js returns the cart in JSON
ShopifyAPI.changeItem = function(line, quantity, callback) {
    var $body = $(document.body),
        params = {
            type: 'POST',
            url: '/cart/change.js',
            data: 'quantity=' + quantity + '&line=' + line,
            dataType: 'json',
            beforeSend: function() {
                $body.trigger('beforeChangeItem.ajaxCart', [line, quantity]);
            },
            success: function(cart) {
                if ((typeof callback) === 'function') {
                    callback(cart);
                } else {
                    ShopifyAPI.onCartUpdate(cart);
                }
                $body.trigger('afterChangeItem.ajaxCart', [line, quantity, cart]);
            },
            error: function(XMLHttpRequest, textStatus) {
                $body.trigger('errorChangeItem.ajaxCart', [XMLHttpRequest, textStatus]);
                ShopifyAPI.onError(XMLHttpRequest, textStatus);
            },
            complete: function(jqxhr, text) {
                $body.trigger('completeChangeItem.ajaxCart', [this, jqxhr, text]);
            }
        };
    jQuery.ajax(params);
};



/*============================================================================
  Product Options
==============================================================================*/
ShopifyAPI.selectCallback = function(variant, selector) {
    // var moneyFormat = Shopify.money_format;
    var moneyFormat = theme.moneyFormat;
    // Selectors
    if (selector.domIdPrefix.split('-').length > 1) {
        var selectorArray = selector.domIdPrefix.split('-');
        var $addToCart = $('#AddToCart-' + selectorArray[1]);
    } else {
        var $addToCart = $('#AddToCart');
    }

    var $productWrapper = $addToCart.parents('.product-core'), // Defined the Product Dom Scope
        $productPrice = $productWrapper.find('.product-price'),
        $comparePrice = $productWrapper.find('.product-compare-price'),
        $addToCartText = $productWrapper.find('.add-to-cart-text');

    // Variant
    if (variant) {
        // Select a valid variant if available
        if (variant.available) {
            // Available, enable the submit button, change text, show quantity elements
            $addToCart.removeClass('disabled').prop('disabled', false);
            if ($addToCart.hasClass('pre-order')) {
                $addToCartText.html("Pre Order");
            } else {
                $addToCartText.html("Add to Cart");
            }
        } else {
            // Sold out, disable the submit button, change text, hide quantity elements
            $addToCart.addClass('disabled').prop('disabled', true);
            if (!$addToCart.hasClass('inquire')) {
                $addToCartText.html("Sold Out");
            }
        }
        // console.log('variant selected and update price');
        // console.log(selector);
        // Regardless of stock, update the product price
        $productPrice.html(Shopify.formatMoney(variant.price, moneyFormat));

        // Also update and show the product's compare price if necessary
        if (variant.compare_at_price > variant.price) {
            $comparePrice.html(Shopify.formatMoney(variant.compare_at_price, moneyFormat)).show();
        } else {
            $comparePrice.hide();
        }

    } else {
        $addToCart.addClass('disabled').prop('disabled', true);
        if (!$addToCart.hasClass('inquire')) {
            $addToCartText.html("Sold Out");
        }
    }
};
/*============================================================================
  Ajax Shopify Add To Cart
==============================================================================*/
var ajaxCart = (function(module, $) {

    'use strict';

    // Public functions
    var init, loadCart;

    // Private general variables
    var settings, isUpdating, $body;

    // Private plugin variables
    var $formContainer, $addToCart, $cartCountSelector, $cartCostSelector, $cartContainer, $drawerContainer;

    // Private functions
    var updateCountPrice, formOverride, itemAddedCallback, itemErrorCallback, cartUpdateCallback, buildCart, cartCallback, adjustCart, adjustCartCallback, createQtySelectors, qtySelectors, validateQty, cartLimit, fixATCButtons;

    /*============================================================================
      Initialise the plugin and define global options
    ==============================================================================*/
    init = function(options) {

        // Default settings
        settings = {
            formSelector: 'form[action^="/cart/add"]',
            cartContainer: '#CartContainer',
            addToCartSelector: 'input[type="submit"]',
            cartCountSelector: null,
            cartCostSelector: null,
            moneyFormat: '$',
            disableAjaxCart: false,
            enableQtySelectors: true
        };

        // Override defaults with arguments
        $.extend(settings, options);

        // Select DOM elements
        $formContainer = $(settings.formSelector);
        $cartContainer = $(settings.cartContainer);
        $addToCart = $formContainer.find(settings.addToCartSelector);
        $cartCountSelector = $(settings.cartCountSelector);
        $cartCostSelector = $(settings.cartCostSelector);

        // General Selectors
        $body = $(document.body);

        // Track cart activity status
        isUpdating = false;

        fixATCButtons();

        // Setup ajax quantity selectors on the any template if enableQtySelectors is true
        if (settings.enableQtySelectors) {
            qtySelectors();
        }

        // Take over the add to cart form submit action if ajax enabled
        if (!settings.disableAjaxCart && $addToCart.length) {
            formOverride();
        }

        // Run this function in case we're using the quantity selector outside of the cart
        adjustCart();
    };

    loadCart = function() {
        $body.addClass('drawer--is-loading');
        ShopifyAPI.getCart(cartUpdateCallback);
    };

    updateCountPrice = function(cart) {
        if ($cartCountSelector) {
            $cartCountSelector.html(cart.item_count).removeClass('hidden-count');

            if (cart.item_count === 0) {
                $cartCountSelector.addClass('hidden-count');
            }
        }
        if ($cartCostSelector) {
            $cartCostSelector.html(Shopify.formatMoney(cart.total_price, settings.moneyFormat));
        }
    };

    formOverride = function() {
        $formContainer.on('submit', function(evt) {
            evt.preventDefault();
            const $ATCButton = $(evt.target).find('.add-to-cart-btn');
            if ($ATCButton.attr('data-in-cart')) {
                window.location.href = '/cart';
            }
            var proceed = true;
            var $currForm = $(evt.target);
            var $selects = $currForm.find('select');
            $.each($selects, function(i, v) {
                if ($(v).val() == '') {
                    proceed = false;
                    return false;
                }
            });

            if (!proceed) {
                alert('Please select all options');
                return false;
            }

            // Add class to be styled if desired
            $addToCart.removeClass('is-added').addClass('is-adding');

            // Remove any previous quantity errors
            $('.qty-error').remove();

            ShopifyAPI.addItemFromForm(evt.target, itemAddedCallback, itemErrorCallback);

            if (!$ATCButton.attr('data-in-cart')) {
                $ATCButton.attr('data-in-cart', true);
            }
        });
    };

    itemAddedCallback = function(product) {
        $addToCart.removeClass('is-adding').addClass('is-added');

        ShopifyAPI.getCart(function(cart) {
            cartUpdateCallback(cart);
            $body.trigger('afterAddToCart.ajaxCart', cart);
        });
    };

    itemErrorCallback = function(XMLHttpRequest, textStatus, $form = $formContainer) {
        var data = eval('(' + XMLHttpRequest.responseText + ')');
        $addToCart.removeClass('is-adding is-added');

        if (!!data.message) {
            if (data.status == 422) {
                $form.after('<div style="margin-top:10px;color:#AD311B;" class="errors qty-error">' + data.description + '</div>');
            } else {
                alert(data.message + '(' + data.status + '): ' + data.description);
            }
        }
    };

    cartLimit = function(cart) {
        // Check if cart has any restricted quantity items exceeding the limit
        var i, count = ORW.sku_list.length;
        for (i = 0; i < count; i++) {
            if (ORW.sku_list[i] && ORW.qty_limit[i]) {
                var skus_restricted_array = ORW.sku_list[i].split(',');
                var qtyMax = parseInt(ORW.qty_limit[i])
                var cartUpdates = {};
    
                var sku_found = false;
                var j, count2 = cart.items.length;
                for (j = 0; j < count2; j++) {
                    var item = cart.items[j];

                    var x, count3 = skus_restricted_array.length;
                    for (x = 0; x < count3; x++) {
                        var skuLimit = skus_restricted_array[x];
                        if (item.sku === skuLimit && item.quantity > qtyMax) {
                            cartUpdates[item.id] = qtyMax;
                            console.log(`Item ${skuLimit} exceeds max ${qtyMax}, will correct`)
                            break;
                        }
                    }

                    if (sku_found) {
                        break;
                    }
                }
    
                // Send cart update request only if has items exceeding max quantity
                if (Object.keys(cartUpdates).length > 0) {
                    const params = {
                        type: 'POST',
                        url: '/cart/update.js',
                        data: { updates: cartUpdates },
                        dataType: 'json',
                        success: function(cart) {
                            console.log('Cart updated with correct quantity restrictions')
                            loadCart();
                            updateCountPrice(cart);
                            buildCart(cart);
                            // if (isCartPage()) location.reload();
                        },
                        error: function(XMLHttpRequest, textStatus) {
                            $body.trigger('errorChangeItem.ajaxCart', [XMLHttpRequest, textStatus]);
                            ShopifyAPI.onError(XMLHttpRequest, textStatus);
                        },
                        complete: function(jqxhr, text) {
                            $body.trigger('completeChangeItem.ajaxCart', [this, jqxhr, text]);
                        }
                    }
                    jQuery.ajax(params);
                    break;
                }
            }
        }
    }

    cartUpdateCallback = function(cart) {
        // Check for any quantity restrictions on skus
        cartLimit(cart)
        // Update quantity and price
        updateCountPrice(cart);
        buildCart(cart);
    };

    buildCart = function(cart) {
        // Start with a fresh cart div
        $cartContainer.empty();

        // Show empty cart
        if (cart.item_count === 0) {
            $cartContainer
                .append('<p class="ajaxcart__empty">' + "Your bag is currently empty." + '</p>');
            cartCallback(cart);
            return;
        }

        // Handlebars.js cart layout
        var items = [],
            item = {},
            data = {},
            source = $("#CartTemplate").html(),
            template = Handlebars.compile(source);

        console.log(cart.items);

        // Add each item to our handlebars.js data
        $.each(cart.items, function(index, cartItem) {
            /* Hack to get product image thumbnail
             *   - If image is not null
             *     - Remove file extension, add _small, and re-add extension
             *     - Create server relative link
             *   - A hard-coded url of no-image
             */
            if (cartItem.image != null) {
                var prodImg = cartItem.image.replace(/(\.[^.]*)$/, "_medium$1").replace('http:', '');
            } else {
                var prodImg = "//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif";
            }

            // Check if item sku is part of restrict skus
            var limitQty = false;
            var qtyInfo = '';
            var i, count = ORW.sku_list.length;
            for (i = 0; i < count; i++) {
                if (ORW.sku_list[i]) {
                    var skus_restricted_array = ORW.sku_list[i].split(',');

                    var j, count2 = skus_restricted_array.length;
                    for (j = 0; j < count2; j++) {
                        var skuLimit = skus_restricted_array[j];
                        if (skuLimit === cartItem.sku) {
                            limitQty = true;
                            qtyInfo = ORW.qty_info_msg[i];
                            break;
                        }
                    }

                    if (limitQty) {
                        break;
                    }
                }
            }

            // Create item's data object and add to 'items' array
            item = {
                key: cartItem.key,
                line: index + 1, // Shopify uses a 1+ index in the API
                url: cartItem.url,
                img: prodImg,
                name: cartItem.product_title,
                variation: cartItem.variant_title,
                properties: cartItem.properties,
                itemAdd: cartItem.quantity + 1,
                itemMinus: cartItem.quantity - 1,
                itemQty: cartItem.quantity,
                price: Shopify.formatMoney(cartItem.price, settings.moneyFormat),
                vendor: cartItem.vendor,
                linePrice: Shopify.formatMoney(cartItem.line_price, settings.moneyFormat),
                originalLinePrice: Shopify.formatMoney(cartItem.original_line_price, settings.moneyFormat),
                discounts: cartItem.discounts,
                discountsApplied: cartItem.line_price === cartItem.original_line_price ? false : true,
                isGiftCard: cartItem.gift_card,
                limitQty: limitQty,
                qtyInfo: qtyInfo
            };

            items.push(item);
        });

        // Gather all cart data and add to DOM
        data = {
            items: items,
            note: cart.note,
            totalPrice: Shopify.formatMoney(cart.total_price, settings.moneyFormat),
            totalCartDiscount: cart.total_discount === 0 ? 0 : "\u003cp\u003eYou're saving\u003c\/p\u003e".replace('[savings]', Shopify.formatMoney(cart.total_discount, settings.moneyFormat)),
            totalCartDiscountApplied: cart.total_discount === 0 ? false : true
        }

        $cartContainer.append(template(data));

        cartCallback(cart);
    };

    cartCallback = function(cart) {
        $body.removeClass('drawer--is-loading');
        $body.trigger('afterCartLoad.ajaxCart', cart);

        if (window.Shopify && Shopify.StorefrontExpressButtons) {
            Shopify.StorefrontExpressButtons.initialize();
        }
        var caseDiscountCount = 0
        var caseActive = false

        function checkCartCrateDiscount() {
            // Set the global configs to synchronous 
            $.ajaxSetup({
                async: false
            });

            cart.items.forEach(e => {
                $.getJSON(window.Shopify.routes.root + 'products/' + e.handle +'.js', function(product) {
                    if (product.tags.includes("_attr::caseDiscount")) {
                        caseActive = true;
                    }
                    if (!product.tags.includes("wrapper")) {
                        caseDiscountCount += 1*e.quantity;
                    }
                } );
            })

            if (caseActive) {
                changeMessage();
            }

            // Set the global configs back to asynchronous 
            $.ajaxSetup({
                async: true
            });
        }
        
        function changeMessage() {
            if(caseDiscountCount > 0 && caseDiscountCount < 12) {
                var cartMessage = $('.ajaxcart__message');
                cartMessage.text(cartMessage.text().replace("x", 12 - caseDiscountCount))
                cartMessage.removeClass('hide');
            } else if(caseDiscountCount >= 12) {
                var cartMessage = $('.ajaxcart__message');
                cartMessage.text("Case Discount Applied!")
                cartMessage.removeClass('hide');
            }
        }

        checkCartCrateDiscount();
    };

    adjustCart = function() {
        // Delegate all events because elements reload with the cart

        // Add or remove from the quantity
        $body.on('click', '.ajaxcart__qty-adjust', function() {
            if (isUpdating) {
                return;
            }

            var $el = $(this),
                line = $el.data('line'),
                $qtySelector = $el.siblings('.ajaxcart__qty-num'),
                qty = parseInt($qtySelector.val().replace(/\D/g, '')),
                qtyEvent = '';

            var qty = validateQty(qty);

            // Add or subtract from the current quantity
            if ($el.hasClass('ajaxcart__qty--plus')) {
                qty += 1;
                qtyEvent = "add_to_cart"
            } else {
                qty -= 1;
                if (qty <= 0) qty = 0;
                qtyEvent = "subtract_from_cart"
            }

            // If it has a data-line, update the cart.
            // Otherwise, just update the input's number
            if (line) {
                $body.trigger('changeCartItemQty.ajaxCart', [line, qtyEvent]);
                updateQuantity(line, qty);
            } else {
                $qtySelector.val(qty);
            }
        });

        $body.on('click', '.ajaxcart__qty-remove', function(e) {
            e.preventDefault();
            var $el = $(this),
                line = $el.data('line'),
                qtyEvent = "remove_from_cart";

            if (isUpdating) {
                return;
            }
            $body.trigger('changeCartItemQty.ajaxCart', [line, qtyEvent]);
            updateQuantity(line, 0);
        });

        // Update quantity based on input on change
        $body.on('change', '.ajaxcart__qty-num', function() {
            if (isUpdating) {
                return;
            }

            var $el = $(this),
                line = $el.data('line'),
                qty = parseInt($el.val().replace(/\D/g, ''));

            var qty = validateQty(qty);

            // If it has a data-line, update the cart
            if (line) {
                updateQuantity(line, qty);
            }
        });

        // Prevent cart from being submitted while quantities are changing
        $body.on('submit', 'form.ajaxcart', function(evt) {
            if (isUpdating) {
                evt.preventDefault();
            }
        });

        // Highlight the text when focused
        $body.on('focus', '.ajaxcart__qty-adjust', function() {
            var $el = $(this);
            setTimeout(function() {
                $el.select();
            }, 50);
        });

        function updateQuantity(line, qty) {
            isUpdating = true;

            // Add activity classes when changing cart quantities
            var $row = $('.ajaxcart__row[data-line="' + line + '"]').addClass('is-loading');

            if (qty === 0) {
                $row.parent().addClass('is-removed');
            }

            // Slight delay to make sure removed animation is done
            setTimeout(function() {
                ShopifyAPI.changeItem(line, qty, adjustCartCallback);
            }, 250);
        }

        // Save note anytime it's changed
        $body.on('change', 'textarea[name="note"]', function() {
            var newNote = $(this).val();

            // Update the cart note in case they don't click update/checkout
            ShopifyAPI.updateCartNote(newNote, function(cart) {});
        });
    };

    adjustCartCallback = function(cart) {
        // Update quantity and price
        updateCountPrice(cart);

        // Reprint cart on short timeout so you don't see the content being removed
        setTimeout(function() {
            isUpdating = false;
            ShopifyAPI.getCart(buildCart);
        }, 150)
    };

    createQtySelectors = function() {
        // If there is a normal quantity number field in the ajax cart, replace it with our version
        if ($('input[type="number"]', $cartContainer).length) {
            $('input[type="number"]', $cartContainer).each(function() {
                var $el = $(this),
                    currentQty = $el.val();

                var itemAdd = currentQty + 1,
                    itemMinus = currentQty - 1,
                    itemQty = currentQty;

                var source = $("#AjaxQty").html(),
                    template = Handlebars.compile(source),
                    data = {
                        key: $el.data('id'),
                        itemQty: itemQty,
                        itemAdd: itemAdd,
                        itemMinus: itemMinus
                    };

                // Append new quantity selector then remove original
                $el.after(template(data)).remove();
            });
        }
    };

    fixATCButtons = function() {
        // Check the cart and fix the add to cart buttons if they are already in the cart
        ShopifyAPI.getCart(function(cart) {
            const productIds = cart.items.map(item => item.product_id);
            $('.add-to-cart-btn').each(function() {
                const id = $(this).attr('id');
                const productId = id.split('-')[1];
                if (productIds.includes(parseInt(productId))) {
                    $(this).attr('data-in-cart', true);
                }
            });
        });
    };

    qtySelectors = function() {
        // Change number inputs to JS ones, similar to ajax cart but without API integration.
        // Make sure to add the existing name and id to the new input element
        var numInputs = $('input.enable-qty-selector');

        if (numInputs.length) {
            numInputs.each(function() {
                var $el = $(this),
                    currentQty = $el.val(),
                    inputName = $el.attr('name'),
                    inputId = $el.attr('id'),
                    dataContinueSelling = $el.attr('data-continue-selling');

                var itemAdd = currentQty + 1,
                    itemMinus = currentQty - 1,
                    itemQty = currentQty;

                var source = $("#JsQty").html(),
                    template = Handlebars.compile(source),
                    data = {
                        key: $el.data('id'),
                        dataContinueSelling: dataContinueSelling,
                        itemQty: itemQty,
                        itemAdd: itemAdd,
                        itemMinus: itemMinus,
                        inputName: inputName,
                        inputId: inputId
                    };

                // Append new quantity selector then remove original
                $el.after(template(data)).remove();
            });

            // Setup listeners to add/subtract from the input
            $('.js-qty__adjust').on('click', function() {
                var $el = $(this),
                    id = $el.data('id'),
                    $qtySelector = $el.siblings('.js-qty__num'),
                    qty = parseInt($qtySelector.val().replace(/\D/g, '')),
                    dataContinueSelling = $qtySelector.attr('data-continue-selling');


                var qty = validateQty(qty);

                // Check if item is limited quantity sku and set max if it is
                var productInfo = $el[0].closest('.product-info');
                var skuHTML;
                if (productInfo) {
                    skuHTML = productInfo.querySelector('.product-quantity-max');
                }

                var sku_found = false;
                var qtyMax, i, count = ORW.sku_list.length;
                for (i = 0; i < count; i++) {
                    if (ORW.sku_list[i] && ORW.qty_limit[i] && skuHTML) {
                        var skus_restricted_array = ORW.sku_list[i].split(',');
                        var itemSKU = skuHTML.dataset.sku;

                        var j, count2 = skus_restricted_array.length;
                        for (j = 0; j < count2; j++) {
                            var skuLimit = skus_restricted_array[j];
                            if (skuLimit === itemSKU) {
                                qtyMax = parseInt(ORW.qty_limit[i]);
                                break;
                            }
                        }

                        if (sku_found) {
                            break;
                        }
                    }
                }

                // Add or subtract from the current quantity
                if ($el.hasClass('js-qty__adjust--plus')) {
                    if(dataContinueSelling == 'false') {
                        // Allow increase if there is no max or if there is a max and the qty is lower than the max
                        if (!qtyMax || (qtyMax && qty < qtyMax)) {
                            qty += 1;
                        }
                    } else {
                        qty += 1;
                    }
                } else {
                    qty -= 1;
                    if (qty <= 1) qty = 1;
                }

                // Update the input's number
                $qtySelector.val(qty);
            });
        }
    };

    validateQty = function(qty) {
        if ((parseFloat(qty) == parseInt(qty)) && !isNaN(qty)) {
            // We have a valid number!
        } else {
            // Not a number. Default to 1.
            qty = 1;
        }
        return qty;
    };

    module = {
        init: init,
        load: loadCart
    };

    return module;

}(ajaxCart || {}, jQuery));